import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


const About = () => {



  return (
    <div>

      <div className='mt-10 text-center px-3' data-aos="fade-up" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="350">
        <h1 className='text-xl font-bold underline text-main'>
          קצת עליי
        </h1>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          שמי אנאל, קוסמטיקאית פרא רפואית, מתמחה בטיפול בבעיות עור : אקנה ,פיגמנטציה, אנטי אייג’ינג, אייג’ינג, טיפולי פלאזמה - הסרת קמטוטים, סימני מתיחה (כולל אזור הבטן ) ,טיפול בצלקות אקנה, הסרת סרחי עור ובנוסף, טיפולי טיפוח ויופי - הרמת ריסים / הרמת גבות, עיצוב גבות ועוד.         </p>

        <p className='text-lg font-normal max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main' dir='rtl'>
          אצלי בקליניקה אני מקפידה על עבודה יסודית, התאמת הטיפול באופן אישי לכל לקוח/ה, היגיינה קפדנית ואוירת רוגע ופינוק.        </p>






        <p className='text-lg font-bold max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main' dir='rtl'>

          מזמינה אתכם ליצור קשר בקליק.   </p>
      </div>

    </div>

  )

}


export default About